/**
 * The Contour Shell mark (see design/brand-and-visual-direction.md § Logo mark).
 * Outer ring uses currentColor so it adapts to its background (dark on light,
 * light on the dark footer); the inner hexagon stays a fixed accent color
 * everywhere, so the mark reads as a considered two-tone form.
 */
export function BasaltMark({ size = 24 }: { size?: number }) {
  return (
    <svg
      className="mark"
      viewBox="0 0 100 100"
      width={size}
      height={size}
      aria-hidden="true"
    >
      <polygon
        points="50,12 82.9,31 82.9,69 50,88 17.1,69 17.1,31"
        fill="none"
        stroke="currentColor"
        strokeWidth={6}
      />
      <polygon
        points="50,34 63.9,42 63.9,58 50,66 36.1,58 36.1,42"
        fill="var(--glacier)"
      />
    </svg>
  );
}
